export const environment = {
    apiUrl: 'https://xcf-backend-dev.fly.dev',
    overviewAppUrl: 'https://apps-overview.fly.dev',
    auth: {
        domain: 'auth.online-xchange.com',
        clientId: 'tveS5RALvFeLRDitolcZ1Qx7YcNo1gLD',
        audience: 'https://auth-app.online-xchange.com'
    }
};
